import "./index.scss";
import { INTERNAL_PATHS } from "routes/paths";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const Disclosure = () => (
  <div className="disclosure">
    <ReactHelmetWithProvider>
      <meta
        name="description"
        content="Discover how GCX LLC complies with FTC regulations to protect users and ensure safe, transparent transactions in our secure marketplace."
      />
      <title>GCX LLC – FTC Disclosure and Compliance | Secure Marketplace</title>
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL + INTERNAL_PATHS.FTC_DISCLOSURE}
      />
    </ReactHelmetWithProvider>
  <ReactHelmetWithProvider>
      <title>GCX LLC – FTC Disclosure and Compliance | Secure Marketplace</title>
      <link
        rel="canonical"
        href={process.env.REACT_APP_URL + INTERNAL_PATHS.FTC_DISCLOSURE}
      />
    </ReactHelmetWithProvider>
    <h1>Raise Marketplace FTC Disclosure</h1>
    <p>
      The disclosure that follows is our attempt to fully comply with the FTC’s
      policy that demands we be transparent about any and all affiliate
      relations we may have on this website. In plain English you, the visitor
      or customer, should assume that any and all links on this site are
      affiliate links. If you click on these links and go visit the resulting
      site, a cookie will be set in your web browser that will cause us to
      receive a commission “IF” you purchase a product on the other end. This is
      a legitimate way to monetize and pay for the operation of web sites and we
      gladly reveal our affiliate relationships to you.
    </p>
    <p>
      In addition we fully disclose that hyperlinks on this site are in most
      cases shortened, and in some cases cloaked to hide long ugly links for
      functionality and tracking purposes. We have nothing to hide and we are
      proud of our relationship with the fine vendors, products and services
      found on this site. Link tracking, shortening and cloaking is a very
      common practice on all types of websites.
    </p>
    <p>
      Further, we do not receive physical products or cash directly in exchange
      for any reviews or posts you find on this site. No one has paid us to do
      reviews or posts. We have to tell you that it is possible that our reviews
      and posts are influenced by our affiliate relationships and may create a
      conflict of interest. We do not believe a conflict of interest exists, but
      you, the visitor or customer, must decide by considering the affiliate
      relationships and link techniques we have described. Obviously we would
      like you to buy the service or products we write about and we are
      influenced by that fact. We avoid conflict by only reviewing or posting
      about products and services we trust. We strive to always give our honest
      opinions, findings, beliefs, or experiences on topics or products we write
      about and promote. Other vendors may also pay to place advertising on our
      sites in the form of banners, widgets, and hyperlinks. These are paid
      advertisements and while we do our best to only allow quality products and
      services to be advertised on our site, we are not responsible for claims
      or testimonials made on paid advertising links.
    </p>
    <p>
      The following represents a more legally worded document but basically
      states the same information presented in the English Translation above.
    </p>
    <p>
      Compensation &amp; Affiliate Disclaimer policy, valid from 13 January 2010
      on. As directed by the FEDERAL TRADE COMMISSION, (see 16 CFR Part 255) –
      Guides Concerning the Use of Endorsements and Testimonials in Advertising,
      the purpose of this policy is to establish any compensatory affiliation
      between the site owner and affiliate networks Amazon, Clickbank,
      Commission Junction, Google, Share-A-Sale and any individual vendors they
      represent and that the site owner has established an affiliate
      relationship.
    </p>
    <p>
      This website may at times accept forms of cash advertising, sponsorship,
      paid insertions or other forms of affiliate compensation.
    </p>
    <p>
      The compensation received may or may not influence the advertising
      content, topics or posts made on this site. That content, advertising
      space or post may not always be identified as paid or sponsored content.
      Not all content is written or presented for the sole purpose of receiving
      affiliate income.
    </p>
    <p>
      The owner(s) of this website is compensated through various affiliate
      programs and some content presents opinions on products, services,
      websites and various other topics. Even though the owner(s) of this
      website may receive affiliate compensation for reviews or advertisements,
      we always give our honest opinions, findings, beliefs, or experiences on
      those topics or products. The views and opinions expressed on this website
      are purely the website’s’ own. Any product claim, statistic, quote or
      other representation about a product or service should be verified with
      the manufacturer, provider or party in question.
    </p>
    <p>
      This website does contain some content which may or may not present a
      conflict of interest. This content may not always be immediately
      identified due to the nature of posting methods. When possible every
      attempt will be made to identify advertising from general non-advertising
      content.
    </p>
  </div>
);
